import { useEffect, useMemo } from 'react';
import { useFormikContext } from 'formik';
import debounce from 'lodash.debounce';
import { IAutoSaveProps } from '@components/AutoSave/types';

export const AutoSave = ({ debounceMs }: IAutoSaveProps) => {
  const formik = useFormikContext();

  const debouncedSubmit = useMemo(
    () => debounce(() => {
      formik.submitForm();
    }, debounceMs),
    [debounceMs, formik],
  );

  useEffect(() => {
    debouncedSubmit();
  }, [debouncedSubmit, formik.values]);

  return null;
};
